import React, { useMemo } from 'react';
import { useRotation } from '../hooks/useRotation';
import { Animated, StyleProp, View, ViewStyle } from 'react-native';
import { CustomIcon } from './CustomIcon';
import getGlobalStyles from '../globalStyles';
import { IconSource } from 'react-native-paper/lib/typescript/components/Icon';
import { Text } from 'react-native-paper';
import { useThemeSettings } from '../ThemeProvider';
import ThinkOLogo from './ThinkoLogo';
import CustomLinearGradient, { GRADIENT_TYPE } from './CustomLinearGradient';

interface ApploaderProps {
  isLoading?: boolean,
  icon?: IconSource,
  style?: StyleProp<ViewStyle>,
  title?: string,
  description?: string,
  size?: number,
}

export default function AppLoader({ isLoading = true, icon, style, title, description, size }: ApploaderProps) {
  const anim = useRotation(isLoading, 2000);
  const { theme } = useThemeSettings();
  const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);

  const rotate = anim.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg'],
  });
  return (
      <View style={[gStyles.centerContainer, { gap: 20 }, style]} >
        <View style={{ marginTop: 100, justifyContent: 'flex-start' }}>
          <Animated.View style={isLoading ? { transform: [{ rotate }] } : {}}>
            {icon ? <CustomIcon icon={icon} size={size ?? 114} /> :
              <ThinkOLogo size={size ?? 114} />}
          </Animated.View></View>
        <View style={[gStyles.centerContainer, { justifyContent: 'flex-start', maxWidth: 350, gap: 20 }]}>
          <Text style={gStyles.centerMessage}>{title ?? ''}</Text>
          <Text style={{ color: theme.colors.secondary, fontSize: 24, fontStyle: 'italic' }}>{description ?? ''}</Text>
        </View>
      </View>
  );
}
